import enumMixin from '@/concern/enumMixin'
import constMixin from '@/concern/constMixin'
/**
 * 受賞者リンクutilクラス
 */
 class WinnerLinkUtil {
  /**
   * 各winnerの受賞種別から、URLを生成して返す
   */
  static getUrl (winner) {
    const enumData = enumMixin.data()
    const constData = constMixin.data()
    let url = '/'
    if (!winner) return url
    if (winner.awardType == enumData.EnumAwardTypeTcc10Sen2021) {
      url = (`/t10s/2021/${winner.id}`)
    } else if (winner.awardType == enumData.EnumAwardTypeTcc10Sen2020) {
      url = (`/t10s/2020/${winner.id}`)
    } else if (winner.awardType == enumData.EnumAwardTypeTcc10Sen2019) {
      url = (`/t10s/2019/${winner.id}`)
    } else if (winner.awardType == enumData.EnumAwardTypeTcc10Sen2018) {
      url = (`/t10s/2018/${winner.id}`)
    } else if (winner.awardType == enumData.EnumAwardTypeTcc10Sen2017) {
      url = (`/t10s/2017/${winner.id}`)
    } else if (winner.awardType == enumData.EnumAwardTypeTcc10Sen2016) {
      url = (`/t10s/2016/${winner.id}`)
    } else if (winner.awardType == enumData.EnumAwardTypeTcc10Sen2015) {
      url = (`/t10s/2015/${winner.id}`)
    } else if (winner.awardType == enumData.EnumAwardTypeTcc10Sen2014) {
      url = (`/t10s/2014/${winner.id}`)
    } else if (winner.awardType == enumData.EnumAwardTypeTcc10Sen2013) {
      url = (`/t10s/2013/${winner.id}`)
    } else if (winner.awardType == enumData.EnumAwardTypeTcc10Sen2012) {
      url = (`/t10s/2012/${winner.id}`)
    } else if (winner.awardType == enumData.EnumAwardTypeJapan100Views) {
      const areaNameJa = constData.prefecturesMap[winner.mainImageTitle]
      const areaNameAlpha = constData.areaAlphabetMap[areaNameJa]
      const prefNameAlpha = constData.prefecturesAlphabetMap[winner.mainImageTitle]
      url = `/j100v/${areaNameAlpha}/${prefNameAlpha}/${winner.id}`
    } else if (winner.awardType == enumData.EnumAwardTypeCastleAndMoon) {
      url = (`/organizer/castleandmoon/${winner.id}`)
    } else if (winner.awardType == enumData.EnumAwardTypeTwitter) {
      url = (`/organizer/twitter/${winner.id}`)
    } else if (winner.awardType == enumData.EnumAwardTypeInstagram) {
      url = (`/organizer/instagram/${winner.id}`)
    } else if (winner.awardType == enumData.EnumAwardTypeJtg) {
      url = (`/organizer/jtg/${winner.id}`)
    } else if (winner.awardType == enumData.EnumAwardTypeWeibo) {
      url = (`/organizer/weibo/${winner.id}`)
    } else if (winner.awardType == enumData.EnumAwardTypeMonogatary) {
      url = (`/organizer/monogatary/${winner.id}`)
    } else if (winner.awardType == enumData.EnumAwardTypeSpecialExhibitons) {
      url = (`/sponsors/${winner.id}`)
    }
    return url
  }
}
  
export default WinnerLinkUtil
